export const GET_ALL_BEDS_PATIENTS_ENDPOINT =
  'api/ipd/bed-patient-assignments/getAllBedAndPatientsByStatusAndLocation'
export const GET_ASSIGNED_PATIENTS_FOR_A_BED_ENDPOINT =
  'api/ipd/bed-patient-assignments/getAssignedPatientForABed?bedStatus='
export const ALL_NOTIFICATIONS_STATUS =
  'api/ipd/notificationstatus/getAllNotifications'
export const ODOOCOGNITIVECARE_URL = '/api/v1/download_invoice_template'
export const ODOOCOGNITIVECARE_INVOICE_URL = '/odoo/invoicing'
export const SEND_WHATSAPP_MESSAGE = '/ipd/notification/sendNotification'
export const DMS_UPLOAD_AND_SEND_NOTIFICATION = '/ipd/notification/upload-file'
export const radiologySearchEndpoint = 'api/ipd/radiology/radiologyOrdersSearch'

export const GET_OPD_DIAGNOSIS_ENDPOINT =
  'api/thopopdservice/v1/opd/getDiagnosis?encounterId='
export const POST_OPD_DIAGNOSIS_ENDPOINT =
  'api/thopopdservice/v1/opd/saveDiagnosis'
export const GET_OPD_SYSTEMIC_ENDPOINT =
  'api/thopopdservice/v1/opd/getSystemicExamination?encounterId='
export const POST_OPD_SYSTEMIC_ENDPOINT =
  'api/thopopdservice/v1/opd/saveSystemicExamination'
export const GET_OPD_HISTORY_ENDPOINT =
  'api/thopopdservice/v1/opd/getHistoryAndExamination?encounterId='
export const POST_OPD_HISTORY_ENDPOINT =
  'api/thopopdservice/v1/opd/saveHistoryAndExamination'
export const GET_OPD_VITALS_ENDPOINT =
  'api/thopopdservice/v1/opd/getVitals?encounterId='
export const POST_OPD_VITALS_ENDPOINT = 'api/thopopdservice/v1/opd/saveVitals'
export const GET_OPD_TREATMENTPLAN_ENDPOINT =
  'api/thopopdservice/v1/opd/getTreatmentPlan?encounterId='
export const POST_OPD_TREATMENTPLAN_ENDPOINT =
  'api/thopopdservice/v1/opd/saveTreatmentPlan'
export const GET_OPD_PAINHISTORY_ENDPOINT =
  'api/thopopdservice/v1/opd/getPainHistory?encounterId='
export const POST_OPD_PAINHISTORY_ENDPOINT =
  'api/thopopdservice/v1/opd/savePainHistory'
export const GET_OPD_OBJECTIVE_ENDPOINT =
  'api/thopopdservice/v1/opd/getObjective?encounterId='
export const POST_OPD_OBJECTIVE_ENDPOINT =
  'api/thopopdservice/v1/opd/saveObjective'

export const GET_DOCTORS_ENDPOINT = 'api/doctor-app/v1/doctors'

export const GET_DOCUMENT_ID_HASURA_ENDPOINT =
  'api/api/rest/getDocumentIdsForVisitIds'
export const GET_DOCUMENT_BY_ID_DMS_ENDPOINT =
  'api/dms/v1/documents/download?id='
